import httpManager from "@/app/shared/utils/httpManager";

export async function fetchNotifications(page, limit = 50) {
  const response = await httpManager.get(
    `/notifications/?limit=${limit}&offset=${(page - 1) * limit}`
  );
  return response.data;
}
